import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { ButtonToolbar } from 'react-bootstrap';
import {
	loadParents, sendMessage,
	PARENT_SEND_MESSAGE_REQUEST, PARENT_SEND_MESSAGE_SUCCESS, PARENT_SEND_MESSAGE_FAILURE
} from './actions';
import Filter from './Filter';
import List from './List';
import authUtils from '../../auth/utils';
import SendMessageButton from '../../common/components/message/SendMessageButton';
import { withTranslation } from 'react-i18next';

class Parents extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleFilterReset = this.handleFilterReset.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleListSelectionChange = this.handleListSelectionChange.bind(this);
		this.handleSendMessage = this.handleSendMessage.bind(this);
		this.state = {
			selectedEntities: []
		}

	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
		this.props.initializeFilter(filter);
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber });
	}

	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.setState({selectedEntities: []});
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleFilterReset() {
		this.handleFilterSubmit({});
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	handleListSelectionChange(newSelectedEntities) {
		this.setState({ selectedEntities: newSelectedEntities });
	}

	handleSendMessage(values, onSuccess) {
		const { sendMessage } = this.props;
		sendMessage({ ...values, parentIds: this.state.selectedEntities.map(parent => parent.id) }, onSuccess);
	}

	renderListActions() {
		const { canSendMessage, t } = this.props;
		return <ButtonToolbar className='pull-right'>
			{canSendMessage && <SendMessageButton onSendMessage={this.handleSendMessage} to={this.state.selectedEntities.map(p => ({ name: p.fullName, email: p.email }))}
				block={PARENT_SEND_MESSAGE_REQUEST} unblock={[PARENT_SEND_MESSAGE_SUCCESS, PARENT_SEND_MESSAGE_FAILURE]} />}
		</ButtonToolbar>
	}

	render() {
		const { isReadonly, canImpersonate, frontOfficeUrl, currentUser, canSendMessage } = this.props;
		return (
			<div>
				<Filter onSubmit={this.handleFilterSubmit} onReset={this.handleFilterReset} loading={this.props.pagination.loading}/>
				<List isReadonly={isReadonly} onFetchData={this.handleListEvent} data={this.props.data}
					canImpersonate={canImpersonate} frontOfficeUrl={frontOfficeUrl} currentUser={currentUser} {...this.props.pagination}
					selectedEntities={this.state.selectedEntities} onSelectionChange={this.handleListSelectionChange}
					listActions={this.renderListActions()} canSendMessage={canSendMessage}
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		entities: { parents },
		auth: { currentUser },
		configuration: { franchisor }
	} = state;

	const parentsPagination = pagination.parents.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: parentsPagination.ids.map(id => parents[id]),
		pagination: parentsPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'Parents'),
		canImpersonate: authUtils.hasPermission(currentUser, 'ImpersonateFrontOfficeUsers'),
		frontOfficeUrl: franchisor.frontOfficeUrl,
		currentUser,
		canSendMessage: franchisor.enableAdHocMessages && authUtils.hasPermission(currentUser, 'SendMessage')
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadParents,
	sendMessage,
	initializeFilter: (data, fields) => initialize('parentsFilter', data, fields)
})(withTranslation()(Parents));